import React, { useRef, useState } from 'react';
import { autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/react';
import { useOnClickOutside } from 'shared/hooks';

import { ArrowDown, DropdownToogle } from './Dropdown.styles';
import { DropdownProps } from './Dropdown.types';
import { DropdownPopup } from './DropdownPopup/DropdownPopup';
import { DropdownElementProps } from './DropdownPopup/DropdownPopup.types';

export const Dropdown = ({ onClick, items, children }: DropdownProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isOpened, setOpened] = useState(false);
  const { floatingStyles, placement, refs } = useFloating({
    middleware: [offset(4), flip(), shift()],
    placement: 'bottom-end',
    strategy: 'fixed',
    whileElementsMounted: autoUpdate,
  });

  const setFloatingRef = (element: HTMLDivElement | null) => {
    containerRef.current = element;
    refs.setFloating(element);
  };

  useOnClickOutside(containerRef, () => {
    setOpened(false);
  });

  const handleSelectClick = () => {
    setOpened(current => !current);
  };

  const handleClick = (item: DropdownElementProps) => {
    setOpened(false);
    onClick(item);
  };

  return (
    <>
      <DropdownToogle ref={refs.setReference} onClick={handleSelectClick} className="dropdown__toggle">
        {children}
        <ArrowDown />
      </DropdownToogle>
      {isOpened && (
        <DropdownPopup
          innerRef={setFloatingRef}
          floatingStyles={floatingStyles}
          placement={placement}
          items={items}
          onClick={handleClick}
        />
      )}
    </>
  );
};
